import { Button } from '@components/common/Button';
import Footer from '../../layouts/Footer';
import SimpleHeader from '../../layouts/SimpleHeader';

const EmailVerificationRequired: React.FC = () => {
  const refreshPage = (): void => {
    window.location.reload();
  };

  return (
    <div className="min-h-full">
      <SimpleHeader />

      <main className="-mt-24 bg-gray-100">
        <div className="mx-auto px-4 pb-32 sm:px-6 lg:px-8">
          <div className="min-height-content bg-gray-100 ">
            <div className="flex-grow flex min-height-content justify-center items-center bg-gray-100">
              <div className="max-w-lg m-2 p-6 bg-white rounded-lg shadow-lg">
                <h2 className="text-lg font-semibold mb-4">Email Verification Required</h2>
                <p className="mb-4">
                  Your email is not verified. Please check your email and click on the provided link to complete the verification process.
                </p>
                <div className="flex justify-center">
                  <Button variant="primary" onClick={refreshPage}>
                    I have verified my email
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default EmailVerificationRequired;
